// Audit Log Action Types
export const FETCH_AUDIT_LOGS = 'FETCH_AUDIT_LOGS';
export const FETCH_AUDIT_LOGS_SUCCESS = 'FETCH_AUDIT_LOGS_SUCCESS';
export const FETCH_AUDIT_LOGS_FAIL = 'FETCH_AUDIT_LOGS_FAIL';

export const FETCH_AUDIT_LOGS_BY_TYPE = 'FETCH_AUDIT_LOGS_BY_TYPE';
export const FETCH_AUDIT_LOGS_BY_TYPE_SUCCESS = 'FETCH_AUDIT_LOGS_BY_TYPE_SUCCESS';
export const FETCH_AUDIT_LOGS_BY_TYPE_FAIL = 'FETCH_AUDIT_LOGS_BY_TYPE_FAIL';

export const FETCH_AUDIT_LOGS_BY_DATE_RANGE = 'FETCH_AUDIT_LOGS_BY_DATE_RANGE';
export const FETCH_AUDIT_LOGS_BY_DATE_RANGE_SUCCESS = 'FETCH_AUDIT_LOGS_BY_DATE_RANGE_SUCCESS';
export const FETCH_AUDIT_LOGS_BY_DATE_RANGE_FAIL = 'FETCH_AUDIT_LOGS_BY_DATE_RANGE_FAIL';

export const CLEAR_AUDIT_LOGS = 'CLEAR_AUDIT_LOGS';
export const CLEAR_AUDIT_LOG_ERROR = 'CLEAR_AUDIT_LOG_ERROR';
